import { Button, ButtonColor, ButtonVariant, ButtonSize } from '@shipengine/giger';
import { getPaypaImageStyles } from './PaypalStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function Paypal(_ref) {
  let {
    buttonText,
    isLoading,
    disabled,
    cdnUrl,
    onClick
  } = _ref;
  return jsx(Button, {
    color: ButtonColor.SECONDARY,
    "aria-label": buttonText,
    "data-id": "payment-paypal-button",
    disabled: disabled,
    isFullWidth: true,
    isLoading: isLoading,
    variant: ButtonVariant.OUTLINED,
    size: ButtonSize.LARGE,
    onClick: onClick,
    children: buttonText ? jsx("span", {
      children: buttonText
    }) : jsx("img", {
      css: getPaypaImageStyles,
      src: `${cdnUrl}/apps/giger/images/paypal.svg`,
      alt: "Paypal"
    })
  });
}

export { Paypal };
//# sourceMappingURL=Paypal.js.map
